import React from "react";
import { Pressable, Text, View } from "react-native";
import { Avatar } from "../ui/avatar";
import type { api } from "../utils/convex-api";
import { Image } from "react-native";

function TutorCard({
  tutor,
  onPress,
}: {
  tutor: NonNullable<typeof api.parent.home.queries.recommendedTutors._returnType>[0];
  onPress: () => void;
}) {
  return (
    <Pressable
      className="p-2 active:opacity-80 hover:opacity-80 items-center"
      onPress={onPress}
    >
      <Avatar size="lg" className="h-[96] w-[96] lg:h-[128] lg:w-[128]">
        <Image
          className="h-full w-full rounded-full"
          source={tutor?.imageUrl ? { uri: tutor.imageUrl } : undefined}
          style={{ width: 96, height: 96 }}
        />
      </Avatar>

      <View className="h-3" />

      <Text
        numberOfLines={1}
        ellipsizeMode="tail"
        className="text-base text-center leading-[24px] font-geologica-medium font-medium text-black capitalize"
      >
        {tutor?.name ?? ""}
      </Text>

      <Text
        numberOfLines={2}
        ellipsizeMode="tail"
        className="text-sm text-center leading-[20px] font-geologica-medium font-medium text-blackAlpha-900 max-w-[180px]"
      >
        {tutor?.subjects.map((subject: { label: string }) => subject.label).join(", ")}
      </Text>
    </Pressable>
  );
}

export default TutorCard;
